export interface Action {
  type: ActionType
  data: any
}

export interface Message {
  title: string
  message: string
  action?: ActionType[] | ActionType | Action | Action[]
}

export enum ActionType {
  Subscribe = 'subscribe'
}